import { hooks, clipboard, blocks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const handler = () => {
  const { element } = clipboard.accessors.getClipboardData();
  if (!element) return;

  const targetBlockId = blocks.accessors.getBlockIdByElement(element);
  const targetBlockVariationId = blocks.accessors.getVariationIdByElement(element);

  trackEvent(constants.events.BLOCK_PASTED, {
    targetBlockId,
    targetBlockVariationId,
  });
};

const trackBlockPasted = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_AFTER_BLOCK_PASTED, handler);
};

export default trackBlockPasted;
